import { FC, useCallback } from "react";
import {
  capitalize,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ListingPrice } from "@/services/cloudchipr.api";

interface ResourceListingPriceDateSelectProps {
  value: string;
  onChange(value: string): void;
}

export const ResourceListingPriceDateSelect: FC<
  ResourceListingPriceDateSelectProps
> = ({ value, onChange }) => {
  const changeHandler = useCallback(
    (event: SelectChangeEvent) => {
      onChange(event.target.value);
    },
    [onChange],
  );
  return (
    <FormControl size="xsmall" focused={false} sx={{ minWidth: 65 }}>
      <Select
        value={value}
        variant="filled"
        onChange={changeHandler}
        sx={selectStyles}
      >
        {options.map((key) => {
          return (
            <MenuItem value={key} key={key}>
              {capitalize(key)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

const options: (keyof ListingPrice)[] = ["monthly", "daily", "hourly"];

const selectStyles = {
  "& .MuiSelect-select": { pl: 1, pr: "28px !important" },

  "& .MuiSvgIcon-root": {
    width: 20,
  },
  borderRadius: 1,

  "&::before": {
    display: "none",
  },
  "&::after": {
    display: "none",
  },
};
